const theme = {
    themes: {
        light: {
            primary: '#0052FF', // OK.
            secondary: '#381A0A',
            accent: '#82B1FF',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FFC107'
        }
    }
};

export default theme;
